import styled from 'styled-components';
import { Modal } from 'components/atoms/modal';
import { Tree as TreeAtom } from 'components/atoms/tree';
import { PRIVATE } from './types';

export const StyledModal = styled(Modal)`
  .ant-modal-footer {
    padding: var(--spacing-03) 0;
  }
`;

export const Tree = styled(TreeAtom)`
  outline: solid 1px var(--border-color);
  padding: var(--spacing-03);
  border-radius: 0;

  .${PRIVATE} {
    background-color: var(--private-01);

    &:hover {
      background-color: var(--private-02) !important;
    }
  }

  .ant-tree-treenode {
    align-items: center;
    padding: 0;
    width: 100%;

    &:not(.project-phase):hover {
      background: var(--item-hover-bg);
    }

    &.ant-tree-treenode-selected {
      background: var(--primary-color);
      color: var(--white-100);
      &:hover {
        background: var(--blue-50);
      }
      .ant-tree-node-content-wrapper .ant-tree-iconEle {
        color: var(--white-100);
      }
    }

    .ant-tree-node-content-wrapper {
      padding: var(--spacing-02) var(--spacing-03);
      width: 100%;
      margin-right: var(--spacing-01);
      cursor: grab;
      display: flex;
      align-items: center;

      .ant-tree-iconEle {
        color: var(--gray-40);
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-right: var(--spacing-03);
      }

      &:hover,
      &.ant-tree-node-selected {
        background: transparent;
      }
    }
    &.project-phase .ant-tree-node-content-wrapper {
      cursor: default;
      color: var(--gray-50);
    }
  }

  .drag-over,
  .drag-over-gap-bottom {
    padding-bottom: var(--spacing-07);
    .ant-tree-drop-indicator {
      height: 0;
      &:before {
        content: '';
        position: absolute;
        border: 2px dashed var(--primary-color);
        height: 32px;
        top: -2px;
        left: 0;
        display: flex;
        align-items: center;
        right: 0;
      }
      &:after {
        content: none;
      }
    }
  }
  &.dragging .ant-tree-node-content-wrapper {
    cursor: grabbing;
  }
`;
